import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

const faqs = [
  {
    question: "¿Cómo funciona la compra grupal?",
    answer: "Cuando te unes a un paquete, tu pago queda reservado. Si se alcanza el mínimo de participantes antes de que acabe el tiempo, la compra se confirma y recibirás tu producto. Si no se alcanza el mínimo, te devolvemos el dinero automáticamente."
  },
  {
    question: "¿Cuándo me cobran?",
    answer: "El pago se realiza en el momento de unirte al paquete mediante tarjeta de crédito/débito. El cargo se procesa inmediatamente, pero si el grupo no se completa, el reembolso es automático."
  },
  {
    question: "¿Qué pasa si no se alcanza el mínimo de participantes?",
    answer: "Si el tiempo del paquete termina y no se ha alcanzado el mínimo de participantes, recibirás un reembolso automático del 100% de tu pago. El proceso de reembolso puede tardar 5-10 días hábiles dependiendo de tu banco."
  },
  {
    question: "¿Cuánto tiempo tengo para unirme?",
    answer: "Cada paquete tiene un tiempo límite de 24, 48 o 72 horas. Puedes ver el tiempo restante en cada oferta con un contador en tiempo real."
  },
  {
    question: "¿Qué diferencia hay entre Nuevo, CPO y Usado?",
    answer: "**Nuevo**: Producto de fábrica, precintado, con garantía completa de Apple. **CPO (Certified Pre-Owned)**: Reacondicionado y certificado por Apple, como nuevo con garantía. **Usado**: Segunda mano verificado por nosotros, en buen estado funcional."
  },
  {
    question: "¿Cuánto tarda la entrega?",
    answer: "El tiempo de entrega varía según el producto y su condición. Los productos nuevos suelen tardar 3-7 días, los CPO 10-12 días, y los usados hasta 14 días. El tiempo exacto se indica en cada paquete."
  },
  {
    question: "¿El envío está incluido?",
    answer: "Sí, el precio del paquete incluye el envío a cualquier dirección en España peninsular. Para Baleares, Canarias o internacional, puede haber costes adicionales."
  },
  {
    question: "¿Cómo sé el estado de mi pedido?",
    answer: "Una vez confirmada la compra grupal, puedes seguir el estado desde tu panel 'Mis Compras'. Te notificaremos cuando el producto se envíe y cuando esté entregado."
  },
  {
    question: "¿Puedo cancelar después de unirme?",
    answer: "No es posible cancelar manualmente una vez te has unido. Sin embargo, si el grupo no se completa, el reembolso es automático. Esto garantiza que otros participantes no pierdan la oportunidad por cancelaciones."
  },
  {
    question: "¿Los productos tienen garantía?",
    answer: "Sí. Los productos nuevos y CPO incluyen la garantía oficial de Apple. Los productos usados incluyen 6 meses de garantía por nuestra parte."
  }
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 md:py-24 bg-gray-50" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            Preguntas Frecuentes
          </h2>
          <p className="text-muted-foreground">
            Todo lo que necesitas saber sobre las compras grupales
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl border border-border/50 overflow-hidden"
              data-testid={`faq-item-${index}`}
            >
              <button
                className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-gray-50 transition-colors"
                onClick={() => toggleFAQ(index)}
                data-testid={`faq-toggle-${index}`}
              >
                <span className="font-medium pr-4">{faq.question}</span>
                {openIndex === index ? (
                  <ChevronUp className="h-5 w-5 text-muted-foreground flex-shrink-0" />
                ) : (
                  <ChevronDown className="h-5 w-5 text-muted-foreground flex-shrink-0" />
                )}
              </button>
              
              {openIndex === index && (
                <div className="px-6 pb-4 text-muted-foreground">
                  <p className="whitespace-pre-line">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
